module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [(_vm.masterSurvey && _vm.masterSurvey.Survey && _vm.masterSurvey.Survey.pages) ? _c('div', {
    staticClass: "wizard-survey"
  }, [_c('div', {
    staticClass: "wizard-survey-panel-locale-header"
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.W00081))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.W00082))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedLocaleCode),
      expression: "selectedLocaleCode"
    }],
    staticClass: "wizard-survey-locale-code-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedLocaleCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.lang.W00083))]), _vm._v(" "), _vm._l((_vm.surveyLocales), function(value) {
    return _c('option', {
      key: value.LocaleCode,
      domProps: {
        "value": value.LocaleCode
      }
    }, [_vm._v("\n              " + _vm._s(value.LocaleName) + "\n            ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-survey-panel-header"
  }, [_c('div', {
    staticClass: "wizard-survey-panel-header-btn",
    on: {
      "click": function($event) {
        return _vm.moveHeader('l')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-survey-panel-header-elements-container",
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        return _vm.scrollHeader($event)
      }
    }
  }, [_c('div', {
    ref: "wizard-survey-panel-header-elements",
    staticClass: "wizard-survey-panel-header-elements"
  }, [_vm._l((_vm.masterSurvey.Survey.pages), function(page) {
    return _vm._l((page.elements), function(cluster) {
      return _c('div', {
        key: ("pagination-" + (cluster.guid.toUpperCase())),
        staticClass: "wizard-survey-panel-header-element",
        class: {
          active: _vm.activeCluster == cluster
        },
        on: {
          "click": function($event) {
            _vm.activeCluster = cluster
          }
        }
      }, [_c('span', [_vm._v(_vm._s(cluster.title))]), _vm._v(" "), (_vm.scenarioQuestionSettings_Visible[cluster.guid.toUpperCase()] || _vm.scenarioQuestionSettings_NotVisible[cluster.guid.toUpperCase()]) ? _c('span', {
        staticClass: "scenario-question-settings-container"
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("visibility")])]) : _vm._e()])
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "wizard-survey-panel-header-btn",
    on: {
      "click": function($event) {
        return _vm.moveHeader('r')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")])])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-survey-panel-sub-header",
    staticStyle: {
      "justify-content": "flex-start",
      "padding-left": "5px",
      "min-height": "5px"
    }
  }, [(_vm.activeCluster && (_vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()] || _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()])) ? _c('div', {
    staticClass: "wizard-survey-row"
  }, [(_vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()] && _vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00087))]), _vm._v(" "), (
    _vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].Scenarios &&
    _vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].Scenarios.length == 0 &&
    _vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].ScenariosNotInConfig &&
    _vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].ScenariosNotInConfig.length != 0
  ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00099))]) : _vm._l((_vm.scenarioQuestionSettings_Visible[_vm.activeCluster.guid.toUpperCase()].Scenarios), function(scenario, index) {
    return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n              " + _vm._s(scenario) + "\n            ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()] && _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00088))]), _vm._v(" "), (
    _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].Scenarios &&
    _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].Scenarios.length == 0 &&
    _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].ScenariosNotInConfig &&
    _vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].ScenariosNotInConfig.length != 0
  ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00100))]) : _vm._l((_vm.scenarioQuestionSettings_NotVisible[_vm.activeCluster.guid.toUpperCase()].Scenarios), function(scenario, index) {
    return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n              " + _vm._s(scenario) + "\n            ")])
  })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.masterSurvey.Survey.pages), function(page) {
    return _c('div', {
      key: page.guid
    }, _vm._l((page.elements), function(cluster) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.activeCluster.guid.toUpperCase() == cluster.guid.toUpperCase()),
          expression: "activeCluster.guid.toUpperCase() == cluster.guid.toUpperCase()"
        }]
      }, [_c('div', {
        key: cluster.guid,
        staticClass: "wizard-survey-panel-sub-header"
      }, [_c('div', {
        staticClass: "wizard-survey-row-half"
      }, [_c('div', {
        staticClass: "wizard-survey-panel-title"
      }, [_c('b', [_c('span', {
        ref: "wizard-survey-contenteditable",
        refInFor: true,
        staticClass: "wizard-survey-contenteditable text-bold",
        attrs: {
          "contenteditable": false,
          "data-questionguid": cluster.guid.toUpperCase(),
          "data-key": 'Title',
          "data-fallbacktext": cluster.title
        }
      })])])]), _vm._v(" "), _c('div', {
        staticClass: "wizard-survey-row-half"
      }, [_c('input', {
        ref: "wizard-survey-translation-input",
        refInFor: true,
        staticClass: "wizard-survey-translation-input",
        attrs: {
          "type": "text",
          "data-translationguid": cluster.guid.toUpperCase(),
          "data-translationkey": 'title',
          "data-category": 'question',
          "disabled": true
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "wizard-survey-panel-sub-header",
        staticStyle: {
          "padding-bottom": "5px",
          "border-bottom": "2px solid #e0e0e0"
        }
      }, [_c('div', {
        staticClass: "wizard-survey-row-half"
      }, [_c('div', {
        staticStyle: {
          "width": "5px"
        }
      }), _vm._v(" "), _c('span', {
        ref: "wizard-survey-contenteditable",
        refInFor: true,
        staticClass: "wizard-survey-contenteditable",
        class: {
          'placeholder-active': !cluster.description && !(_vm.questionsByGuid[cluster.guid.toUpperCase()] && _vm.questionsByGuid[cluster.guid.toUpperCase()].Description)
        },
        attrs: {
          "contenteditable": false,
          "data-questionguid": cluster.guid.toUpperCase(),
          "data-key": 'Description',
          "data-fallbacktext": cluster.description ? cluster.description : _vm.lang.W00085,
          "data-placeholder": (cluster.description || (_vm.questionsByGuid[cluster.guid.toUpperCase()] && _vm.questionsByGuid[cluster.guid.toUpperCase()].Description)) ? false : true
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "wizard-survey-row-half"
      }, [_c('input', {
        ref: "wizard-survey-translation-input",
        refInFor: true,
        staticClass: "wizard-survey-translation-input",
        attrs: {
          "type": "text",
          "data-translationguid": cluster.guid.toUpperCase(),
          "data-translationkey": 'description',
          "data-category": 'question',
          "disabled": true
        }
      })])]), _vm._v(" "), _vm._l((cluster.elements), function(element1) {
        return [(element1.type == 'panel') ? _c('div', {
          staticClass: "wizard-survey-panel"
        }, [_c('div', {
          staticClass: "wizard-survey-row"
        }, [_c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('div', {
          staticClass: "wizard-survey-panel-title"
        }, [_c('b', [_c('span', {
          ref: "wizard-survey-contenteditable",
          refInFor: true,
          staticClass: "wizard-survey-contenteditable text-bold",
          attrs: {
            "contenteditable": !_vm.readonly,
            "data-questionguid": element1.guid.toUpperCase(),
            "data-key": 'Title',
            "data-fallbacktext": element1.title
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'Title', $event.target.textContent, $event.target)
            }
          }
        })]), _vm._v(" "), (_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()] || _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()]) ? _c('span', {
          staticClass: "scenario-question-settings-container"
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("visibility")]), _vm._v(" "), _c('div', {
          staticClass: "scenario-question-settings-popup"
        }, [(_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()] && _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00087))]), _vm._v(" "), (
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios.length == 0 &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].ScenariosNotInConfig &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].ScenariosNotInConfig.length != 0
        ) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00099) + "\n                          ")]) : _vm._l((_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios), function(scenario, index) {
          return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(scenario) + "\n                          ")])
        })], 2) : _vm._e(), _vm._v(" "), (_vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()] && _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00088))]), _vm._v(" "), (
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios.length == 0 &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].ScenariosNotInConfig &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].ScenariosNotInConfig.length != 0
        ) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00100) + "\n                          ")]) : _vm._l((_vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios), function(scenario, index) {
          return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(scenario) + "\n                          ")])
        })], 2) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('input', {
          ref: "wizard-survey-translation-input",
          refInFor: true,
          staticClass: "wizard-survey-translation-input",
          attrs: {
            "type": "text",
            "data-translationguid": element1.guid.toUpperCase(),
            "data-translationkey": 'title',
            "data-category": 'question',
            "disabled": _vm.readonly || !_vm.selectedLocaleCode
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestionTranslation(element1.guid.toUpperCase(), 'TranslationTitle', $event.target.value, $event.target)
            }
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row"
        }, [_c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('div', {
          staticStyle: {
            "width": "5px"
          }
        }), _vm._v(" "), _c('span', {
          ref: "wizard-survey-contenteditable",
          refInFor: true,
          staticClass: "wizard-survey-contenteditable",
          class: {
            'placeholder-active': !element1.description && !(_vm.questionsByGuid[element1.guid.toUpperCase()] && _vm.questionsByGuid[element1.guid.toUpperCase()].Description)
          },
          attrs: {
            "contenteditable": !_vm.readonly,
            "data-questionguid": element1.guid.toUpperCase(),
            "data-key": 'Description',
            "data-fallbacktext": element1.description ? element1.description : _vm.lang.W00085,
            "data-placeholder": (element1.description || (_vm.questionsByGuid[element1.guid.toUpperCase()] && _vm.questionsByGuid[element1.guid.toUpperCase()].Description)) ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.removePlaceholder($event.target)
            },
            "input": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'Description', $event.target.textContent, $event.target)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('input', {
          ref: "wizard-survey-translation-input",
          refInFor: true,
          staticClass: "wizard-survey-translation-input",
          attrs: {
            "type": "text",
            "data-translationguid": element1.guid.toUpperCase(),
            "data-translationkey": 'description',
            "data-category": 'question',
            "disabled": _vm.readonly || !_vm.selectedLocaleCode
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestionTranslation(element1.guid.toUpperCase(), 'TranslationDescription', $event.target.value, $event.target)
            }
          }
        })])]), _vm._v(" "), _vm._l((element1.elements), function(element2) {
          return _c('div', {
            staticClass: "wizard-survey-question"
          }, [(_vm.debug) ? _c('span', [_vm._v(_vm._s(element2.guid.toUpperCase()))]) : _vm._e(), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row"
          }, [_c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('input', {
            key: ("wizard-survey-input-" + (element2.guid.toUpperCase()) + "-IsSelected"),
            staticClass: "wizard-survey-input-isSelected",
            attrs: {
              "type": "checkbox",
              "disabled": _vm.readonly
            },
            domProps: {
              "checked": (_vm.questionsByGuid[element2.guid.toUpperCase()]) ? _vm.questionsByGuid[element2.guid.toUpperCase()].IsSelected : true
            },
            on: {
              "change": function($event) {
                _vm.setConfigurationQuestion(element2.guid.toUpperCase(), 'IsSelected', $event.target.checked, $event.target)
              }
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "wizard-survey-question-title"
          }, [_c('span', {
            staticClass: "text-bold"
          }, [_vm._v(_vm._s(element2.customQuestionNumber))]), _vm._v(" "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable text-bold",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-questionguid": element2.guid.toUpperCase(),
              "data-key": 'Title',
              "data-fallbacktext": element2.title
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestion(element2.guid.toUpperCase(), 'Title', $event.target.textContent, $event.target)
              }
            }
          }), _vm._v(" "), _c('span', {
            staticClass: "text-bold"
          }, [_vm._v(_vm._s(element2.isRequired ? '*' : ''))]), _vm._v(" "), _c('em', [_vm._v("(" + _vm._s(element2.type) + ")")]), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (false),
              expression: "false"
            }]
          }, [_vm._v(_vm._s(element2.guid.toUpperCase()))])]), _vm._v(" "), (_vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()] || _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()]) ? _c('span', {
            staticClass: "scenario-question-settings-container"
          }, [_c('i', {
            staticClass: "material-icons"
          }, [_vm._v("visibility")]), _vm._v(" "), _c('div', {
            staticClass: "scenario-question-settings-popup"
          }, [(_vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()] && _vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00087))]), _vm._v(" "), (
            _vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].Scenarios &&
            _vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].Scenarios.length == 0 &&
            _vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].ScenariosNotInConfig &&
            _vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].ScenariosNotInConfig.length != 0
          ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00099))]) : _vm._l((_vm.scenarioQuestionSettings_Visible[element2.guid.toUpperCase()].Scenarios), function(scenario, index) {
            return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(scenario) + "\n                          ")])
          })], 2) : _vm._e(), _vm._v(" "), (_vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()] && _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00088))]), _vm._v(" "), (
            _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].Scenarios &&
            _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].Scenarios.length == 0 &&
            _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].ScenariosNotInConfig &&
            _vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].ScenariosNotInConfig.length != 0
          ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00100))]) : _vm._l((_vm.scenarioQuestionSettings_NotVisible[element2.guid.toUpperCase()].Scenarios), function(scenario, index) {
            return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                            " + _vm._s(scenario) + "\n                          ")])
          })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (element2.type == 'checkbox') ? _c('span', {
            staticClass: "span-max-points"
          }, [_vm._v("\n                      " + _vm._s(_vm.lang.W00084) + "\n                      "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-questionguid": element2.guid.toUpperCase(),
              "data-key": 'PointsMax',
              "data-fallbacktext": element2.pointsMax ? element2.pointsMax : 0
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestion(element2.guid.toUpperCase(), 'PointsMax', $event.target.textContent, $event.target, 'number')
              }
            }
          })]) : _vm._e()]), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('input', {
            ref: "wizard-survey-translation-input",
            refInFor: true,
            staticClass: "wizard-survey-translation-input",
            attrs: {
              "type": "text",
              "data-translationguid": element2.guid.toUpperCase(),
              "data-translationkey": 'title',
              "data-category": 'question',
              "disabled": _vm.readonly || !_vm.selectedLocaleCode
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionTranslation(element2.guid.toUpperCase(), 'TranslationTitle', $event.target.value, $event.target)
              }
            }
          })])]), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row"
          }, [_c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('div', {
            staticClass: "wizard-survey-spacer"
          }), _vm._v(" "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable",
            class: {
              'placeholder-active': !element2.description && !(_vm.questionsByGuid[element2.guid.toUpperCase()] && _vm.questionsByGuid[element2.guid.toUpperCase()].Description)
            },
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-questionguid": element2.guid.toUpperCase(),
              "data-key": 'Description',
              "data-fallbacktext": element2.description ? element2.description : _vm.lang.W00085,
              "data-placeholder": (element2.description || (_vm.questionsByGuid[element2.guid.toUpperCase()] && _vm.questionsByGuid[element2.guid.toUpperCase()].Description)) ? false : true
            },
            on: {
              "click": function($event) {
                return _vm.removePlaceholder($event.target)
              },
              "input": function($event) {
                _vm.setConfigurationQuestion(element2.guid.toUpperCase(), 'Description', $event.target.textContent, $event.target)
              }
            }
          })]), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('input', {
            ref: "wizard-survey-translation-input",
            refInFor: true,
            staticClass: "wizard-survey-translation-input",
            attrs: {
              "type": "text",
              "data-translationguid": element2.guid.toUpperCase(),
              "data-translationkey": 'description',
              "data-category": 'question',
              "disabled": _vm.readonly || !_vm.selectedLocaleCode
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionTranslation(element2.guid.toUpperCase(), 'TranslationDescription', $event.target.value, $event.target)
              }
            }
          })])]), _vm._v(" "), _vm._l((element2.choices), function(c) {
            return (element2.choices) ? _c('div', {
              staticClass: "wizard-survey-row"
            }, [_c('div', {
              staticClass: "wizard-survey-row-half"
            }, [_c('div', {
              staticClass: "wizard-survey-spacer"
            }), _vm._v(" "), (element2.type == 'radiogroup') ? _c('input', {
              staticStyle: {
                "cursor": "default",
                "margin": "0px"
              },
              attrs: {
                "type": "radio",
                "name": "",
                "id": "",
                "disabled": ""
              }
            }) : _vm._e(), _vm._v(" "), (element2.type == 'checkbox') ? _c('input', {
              staticStyle: {
                "cursor": "default",
                "margin": "0px"
              },
              attrs: {
                "type": "checkbox",
                "name": "",
                "id": "",
                "disabled": ""
              }
            }) : _vm._e(), _vm._v(" "), _c('div', {
              staticStyle: {
                "text-align": "justify",
                "max-width": "80%"
              }
            }, [_c('span', {
              ref: "wizard-survey-contenteditable",
              refInFor: true,
              staticClass: "wizard-survey-contenteditable",
              attrs: {
                "contenteditable": !_vm.readonly,
                "data-choiceguid": c.guid.toUpperCase(),
                "data-key": 'Title',
                "data-fallbacktext": c.text
              },
              on: {
                "input": function($event) {
                  _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Title', $event.target.textContent, $event.target)
                }
              }
            })]), _vm._v(" "), (element2.type == 'radiogroup') ? _c('span', {
              staticClass: "wizard-survey-points-container"
            }, [_vm._v("\n                      (\n                      "), _c('span', {
              ref: "wizard-survey-contenteditable",
              refInFor: true,
              staticClass: "wizard-survey-contenteditable",
              attrs: {
                "contenteditable": !_vm.readonly,
                "data-choiceguid": c.guid.toUpperCase(),
                "data-key": 'Points',
                "data-fallbacktext": c.points ? c.points : 0
              },
              on: {
                "input": function($event) {
                  _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Points', $event.target.textContent, $event.target, 'number')
                }
              }
            }), _vm._v("\n                      /\n                      "), _c('span', {
              ref: "wizard-survey-contenteditable",
              refInFor: true,
              staticClass: "wizard-survey-contenteditable text-center",
              attrs: {
                "contenteditable": !_vm.readonly,
                "data-choiceguid": c.guid.toUpperCase(),
                "data-key": 'PointsMax',
                "data-fallbacktext": element2.pointsMax ? element2.pointsMax : 0
              },
              on: {
                "input": function($event) {
                  _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'PointsMax', $event.target.textContent, $event.target, 'number')
                }
              }
            }), _vm._v("\n                      )\n                    ")]) : _vm._e(), _vm._v(" "), (element2.type == 'checkbox') ? _c('span', {
              staticClass: "wizard-survey-points-container"
            }, [_vm._v("\n                      (\n                      "), _c('span', {
              ref: "wizard-survey-contenteditable",
              refInFor: true,
              staticClass: "wizard-survey-contenteditable",
              attrs: {
                "contenteditable": !_vm.readonly,
                "data-choiceguid": c.guid.toUpperCase(),
                "data-key": 'Points',
                "data-fallbacktext": c.points ? c.points : 0
              },
              on: {
                "input": function($event) {
                  _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Points', $event.target.textContent, $event.target, 'number')
                }
              }
            }), _vm._v("\n                      )\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
              staticClass: "wizard-survey-row-half"
            }, [_c('input', {
              ref: "wizard-survey-translation-input",
              refInFor: true,
              staticClass: "wizard-survey-translation-input",
              attrs: {
                "type": "text",
                "data-translationguid": c.guid.toUpperCase(),
                "data-translationkey": 'text',
                "data-category": 'choice',
                "disabled": _vm.readonly || !_vm.selectedLocaleCode
              },
              on: {
                "input": function($event) {
                  _vm.setConfigurationQuestionChoiceTranslation(c.guid.toUpperCase(), 'Translation', $event.target.value, $event.target)
                }
              }
            })])]) : _vm._e()
          }), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row"
          }, [_c('textarea', {
            attrs: {
              "rows": "1",
              "placeholder": _vm.lang.W00086,
              "disabled": _vm.readonly
            },
            on: {
              "change": function($event) {
                _vm.setConfigurationQuestion(element2.guid.toUpperCase(), 'Comment', $event.target.value, $event.target)
              }
            }
          }, [_vm._v(_vm._s(_vm.getComment(element2.guid.toUpperCase())))])])], 2)
        })], 2) : _c('div', {
          staticClass: "wizard-survey-question"
        }, [(_vm.debug) ? _c('span', [_vm._v(_vm._s(element1.guid.toUpperCase()))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row"
        }, [_c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('input', {
          key: ("wizard-survey-input-" + (element1.guid.toUpperCase()) + "-IsSelected"),
          staticClass: "wizard-survey-input-isSelected",
          attrs: {
            "type": "checkbox",
            "disabled": _vm.readonly
          },
          domProps: {
            "checked": (_vm.questionsByGuid[element1.guid.toUpperCase()]) ? _vm.questionsByGuid[element1.guid.toUpperCase()].IsSelected : true
          },
          on: {
            "change": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'IsSelected', $event.target.checked, $event.target)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "wizard-survey-question-title"
        }, [_c('span', {
          staticClass: "text-bold"
        }, [_vm._v(_vm._s(element1.customQuestionNumber))]), _vm._v(" "), _c('span', {
          ref: "wizard-survey-contenteditable",
          refInFor: true,
          staticClass: "wizard-survey-contenteditable text-bold",
          attrs: {
            "contenteditable": !_vm.readonly,
            "data-questionguid": element1.guid.toUpperCase(),
            "data-key": 'Title',
            "data-fallbacktext": element1.title
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'Title', $event.target.textContent, $event.target)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "text-bold"
        }, [_vm._v(_vm._s(element1.isRequired ? '*' : ''))]), _vm._v(" "), _c('em', [_vm._v("(" + _vm._s(element1.type) + ")")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }]
        }, [_vm._v(_vm._s(element1.guid.toUpperCase()))])]), _vm._v(" "), (_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()] || _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()]) ? _c('span', {
          staticClass: "scenario-question-settings-container"
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("visibility")]), _vm._v(" "), _c('div', {
          staticClass: "scenario-question-settings-popup"
        }, [(_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()] && _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00087))]), _vm._v(" "), (
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios.length == 0 &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].ScenariosNotInConfig &&
          _vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].ScenariosNotInConfig.length != 0
        ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00099))]) : _vm._l((_vm.scenarioQuestionSettings_Visible[element1.guid.toUpperCase()].Scenarios), function(scenario, index) {
          return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                          " + _vm._s(scenario) + "\n                        ")])
        })], 2) : _vm._e(), _vm._v(" "), (_vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()] && _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.lang.W00088))]), _vm._v(" "), (
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios.length == 0 &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].ScenariosNotInConfig &&
          _vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].ScenariosNotInConfig.length != 0
        ) ? _c('span', [_vm._v(_vm._s(_vm.lang.W00098) + " " + _vm._s(_vm.lang.W00100))]) : _vm._l((_vm.scenarioQuestionSettings_NotVisible[element1.guid.toUpperCase()].Scenarios), function(scenario, index) {
          return _c('span', [(index) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                          " + _vm._s(scenario) + "\n                        ")])
        })], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), (element1.type == 'checkbox') ? _c('span', {
          staticClass: "span-max-points"
        }, [_vm._v("\n                    " + _vm._s(_vm.lang.W00084) + "\n                    "), _c('span', {
          ref: "wizard-survey-contenteditable",
          refInFor: true,
          staticClass: "wizard-survey-contenteditable",
          attrs: {
            "contenteditable": !_vm.readonly,
            "data-questionguid": element1.guid.toUpperCase(),
            "data-key": 'PointsMax',
            "data-fallbacktext": element1.pointsMax ? element1.pointsMax : 0
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'PointsMax', $event.target.textContent, $event.target, 'number')
            }
          }
        })]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('input', {
          ref: "wizard-survey-translation-input",
          refInFor: true,
          staticClass: "wizard-survey-translation-input",
          attrs: {
            "type": "text",
            "data-translationguid": element1.guid.toUpperCase(),
            "data-translationkey": 'title',
            "data-category": 'question',
            "disabled": _vm.readonly || !_vm.selectedLocaleCode
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestionTranslation(element1.guid.toUpperCase(), 'TranslationTitle', $event.target.value, $event.target)
            }
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row"
        }, [_c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('div', {
          staticClass: "wizard-survey-spacer"
        }), _vm._v(" "), _c('span', {
          ref: "wizard-survey-contenteditable",
          refInFor: true,
          staticClass: "wizard-survey-contenteditable",
          class: {
            'placeholder-active': !element1.description && !(_vm.questionsByGuid[element1.guid.toUpperCase()] && _vm.questionsByGuid[element1.guid.toUpperCase()].Description)
          },
          attrs: {
            "contenteditable": !_vm.readonly,
            "data-questionguid": element1.guid.toUpperCase(),
            "data-key": 'Description',
            "data-fallbacktext": element1.description ? element1.description : _vm.lang.W00085,
            "data-placeholder": (element1.description || (_vm.questionsByGuid[element1.guid.toUpperCase()] && _vm.questionsByGuid[element1.guid.toUpperCase()].Description)) ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.removePlaceholder($event.target)
            },
            "input": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'Description', $event.target.textContent, $event.target)
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row-half"
        }, [_c('input', {
          ref: "wizard-survey-translation-input",
          refInFor: true,
          staticClass: "wizard-survey-translation-input",
          attrs: {
            "type": "text",
            "data-translationguid": element1.guid.toUpperCase(),
            "data-translationkey": 'description',
            "data-category": 'question',
            "disabled": _vm.readonly || !_vm.selectedLocaleCode
          },
          on: {
            "input": function($event) {
              _vm.setConfigurationQuestionTranslation(element1.guid.toUpperCase(), 'TranslationDescription', $event.target.value, $event.target)
            }
          }
        })])]), _vm._v(" "), _vm._l((element1.choices), function(c) {
          return (element1.choices) ? _c('div', {
            staticClass: "wizard-survey-row"
          }, [_c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('div', {
            staticClass: "wizard-survey-spacer"
          }), _vm._v(" "), (element1.type == 'radiogroup') ? _c('input', {
            staticStyle: {
              "cursor": "default",
              "margin": "0px"
            },
            attrs: {
              "type": "radio",
              "name": "",
              "id": "",
              "disabled": ""
            }
          }) : _vm._e(), _vm._v(" "), (element1.type == 'checkbox') ? _c('input', {
            staticStyle: {
              "cursor": "default",
              "margin": "0px"
            },
            attrs: {
              "type": "checkbox",
              "name": "",
              "id": "",
              "disabled": ""
            }
          }) : _vm._e(), _vm._v(" "), _c('div', {
            staticStyle: {
              "text-align": "justify",
              "max-width": "80%"
            }
          }, [_c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-choiceguid": c.guid.toUpperCase(),
              "data-key": 'Title',
              "data-fallbacktext": c.text
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Title', $event.target.textContent, $event.target)
              }
            }
          })]), _vm._v(" "), (element1.type == 'radiogroup') ? _c('span', {
            staticClass: "wizard-survey-points-container"
          }, [_vm._v("\n                    (\n                    "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-choiceguid": c.guid.toUpperCase(),
              "data-key": 'Points',
              "data-fallbacktext": c.points ? c.points : 0
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Points', $event.target.textContent, $event.target, 'number')
              }
            }
          }), _vm._v("\n                    /\n                    "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable text-center",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-choiceguid": c.guid.toUpperCase(),
              "data-key": 'PointsMax',
              "data-fallbacktext": element1.pointsMax ? element1.pointsMax : 0
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'PointsMax', $event.target.textContent, $event.target, 'number')
              }
            }
          }), _vm._v("\n                    )\n                  ")]) : _vm._e(), _vm._v(" "), (element1.type == 'checkbox') ? _c('span', {
            staticClass: "wizard-survey-points-container"
          }, [_vm._v("\n                    (\n                    "), _c('span', {
            ref: "wizard-survey-contenteditable",
            refInFor: true,
            staticClass: "wizard-survey-contenteditable",
            attrs: {
              "contenteditable": !_vm.readonly,
              "data-choiceguid": c.guid.toUpperCase(),
              "data-key": 'Points',
              "data-fallbacktext": c.points ? c.points : 0
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionChoice(c.guid.toUpperCase(), 'Points', $event.target.textContent, $event.target, 'number')
              }
            }
          }), _vm._v("\n                    )\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
            staticClass: "wizard-survey-row-half"
          }, [_c('input', {
            ref: "wizard-survey-translation-input",
            refInFor: true,
            staticClass: "wizard-survey-translation-input",
            attrs: {
              "type": "text",
              "data-translationguid": c.guid.toUpperCase(),
              "data-translationkey": 'text',
              "data-category": 'choice',
              "disabled": _vm.readonly || !_vm.selectedLocaleCode
            },
            on: {
              "input": function($event) {
                _vm.setConfigurationQuestionChoiceTranslation(c.guid.toUpperCase(), 'Translation', $event.target.value, $event.target)
              }
            }
          })])]) : _vm._e()
        }), _vm._v(" "), _c('div', {
          staticClass: "wizard-survey-row"
        }, [_c('textarea', {
          attrs: {
            "rows": "1",
            "placeholder": _vm.lang.W00086,
            "disabled": _vm.readonly
          },
          on: {
            "change": function($event) {
              _vm.setConfigurationQuestion(element1.guid.toUpperCase(), 'Comment', $event.target.value, $event.target)
            }
          }
        }, [_vm._v(_vm._s(_vm.getComment(element1.guid.toUpperCase())))])])], 2)]
      })], 2)
    }), 0)
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff4fd848","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizards/Audi/Step5.vue
// module id = 1740
// module chunks = 1